function cartItemFSProps(el) {
	if (!el) return {};
	return {
		product: el.dataset.fsProduct,
		category: el.dataset.fsCategory,
		productType: el.dataset.fsProductType,
		colour: el.dataset.fsColour
	};
}

class CartContents extends HTMLElement {
	constructor() {
		super();
		this.promise = null;
		this.validating = false;
		this.hash = this.getAttribute('hash');

		const observer = new PerformanceObserver(async list => {
			if (list.getEntries().some(entry => entry.initiatorType === "fetch" && entry.name.match(/\/cart\/(add|update|change).js/))) {
				await this.promise;
				await this.update();
			}
		});

		this.addEventListener('cartupdate', e => this.update());

		observer.observe({ entryTypes: ["resource"] });

		const discountCodes = JSON.parse(this.dataset.codes || []);

		for (const code of discountCodes) {
			if (document.cookie.split(';').some(item => item.includes(`discount_code=${code}`) && !localStorage.getItem(`${code}DiscountApplied`))) {
				this.discountCode = code;
			}
		}

		this.init();

		const params = new URLSearchParams(window.location.search);
		
		if (params.get('free_gift') == 'true') {
			const freeGiftModal = document.getElementById('free-gift-modal');
			if (freeGiftModal) freeGiftModal.open({desktop: 'popup'});
		}
	}

	async update() {
		if (window.preventCartUpdate) return;
		let collapsed = [...this.querySelectorAll('.cart-item--bundle[data-collapsed="true"]')].map(item => item.dataset.bundleId);

		const cartMain = this.querySelector('.cart-main');
		const cartMainScroll = cartMain ? cartMain.scrollTop : 0;
		const wasGiftUnlocked = this.querySelector('.cart__free-gift--unlocked') != null;

		const originalCount = this.querySelectorAll('.cart-item').length;

		const recs = this.querySelector('product-recommendations');
		const recsScroll = recs ? recs.querySelector('card-carousel-items').scrollLeft : 0;

		const nostoRecs = [...this.querySelectorAll('.nosto_element')];

		this.promise = fetch(`/?section_id=cart`);
		let resp = await this.promise;
		let parser = new DOMParser();
		let doc = parser.parseFromString(await resp.text(), 'text/html');

		const newContents = doc.querySelector('cart-contents');

		// Only update if cart items have changed
		const newHash = newContents.getAttribute('hash');
		if (newHash == this.hash) return;
		else this.hash = newHash;

		// A slide-out-modal opened inside the cart drawer portals itself out to <body>, so
		// it's no longer a child here and replaceChildren below won't remove it. Tear down
		// any that originated from this cart so they don't linger after the refresh (the new
		// content brings its own copy). Checked before replaceChildren, while the old origin
		// parent is still attached inside this element.
		for (const modal of document.querySelectorAll('body > slide-out-modal')) {
			if (modal.portalParent && this.contains(modal.portalParent)) modal.removePortaled();
		}

		this.replaceChildren(...newContents.children);

		for (const attr of newContents.attributes) {
			if (attr.name != 'hash') this.setAttribute(attr.name, attr.value);
		}

		for (let item of this.querySelectorAll('.cart-item--bundle')) {
			if (collapsed.includes(item.dataset.bundleId)) item.toggleCollapse(false);
		}

		this.applyDisplayOrder();

		let updatedCartMain = this.querySelector('.cart-main');
		let countElem = document.querySelector('.site-header__cart .cart-count');
		
		if (updatedCartMain) {
			updatedCartMain.scrollTop = cartMainScroll;

			let count = parseInt(this.querySelector('.cart-items').dataset.count);

			countElem.innerHTML = count;
			countElem.style.display = '';
		}
		else countElem.style.display = 'none';

		const newRecs = this.querySelector('product-recommendations');
		if (recs && newRecs) {
			newRecs.querySelector('card-carousel-items').scrollLeft = recsScroll;
			newRecs.addEventListener('loaded', e => {
				console.log('Set scroll to', recsScroll)
				newRecs.querySelector('card-carousel-items').scrollLeft = recsScroll;
			});
		}

		for (const rec of nostoRecs) {
			const newRec = this.querySelector(`#${rec.id}`);
			if (newRec) newRec.replaceWith(rec);
		}

		const newCount = this.querySelectorAll('.cart-item').length;
		if (newCount > originalCount && !!( this.offsetWidth || this.offsetHeight || this.getClientRects().length )) {
			updatedCartMain.scrollTo({ top: 0, behavior: 'smooth' });
		}

		const isGiftUnlocked = this.querySelector('.cart__free-gift--unlocked') != null;
		if (!wasGiftUnlocked && isGiftUnlocked) {
			updatedCartMain.scrollTo({ top: 0, behavior: 'smooth' });
		}

		this.init();
	}

	async validateCart() {
		if (this.validating) return;
		this.validating = true;

		const resp = await fetch('/cart.js');
		const json = await resp.json();
		const items = json.items;

		window.theme.cartItems = items;

		document.documentElement.classList.toggle('cart-empty', items.length == 0);
		document.querySelectorAll('[href^="/checkout"]').forEach(link => link.dataset.total = json.total_price / 100);

		// Remove items with subcomponents when loop returns is active
		if (document.body.classList.contains('loop-returns-activated')) {
			const componentItems = items.filter(item => item.has_components);
			if (componentItems.length > 0) {
				this.dataset.validating = "true";
				const updates = {};
				for (const item of componentItems) {
					updates[item.key] = 0;
				}
				await fetch('/cart/update.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ updates })
				});
				this.validating = false;
				return this.validateCart();
			}
		}

		// Remove items with blank handle
		const blankIdItems = items.filter(item => !item.handle);
		if (blankIdItems.length > 0) {
			this.dataset.validating = "true";
			for (const item of blankIdItems) {
				await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ line: items.indexOf(item) + 1, quantity: 0 })
				});
			}
		}

		// Validate bundles
		for (const item of items) {
			if (item.price === 0 && !item.properties['_ParentPrice'] && (item.sku?.startsWith('BND') || item.sku?.includes('FLSS'))) {
				this.dataset.validating = "true";
				const resp = await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: item.key,
						quantity: 0
					})
				});

				if (resp.ok) {
					await addToCartGlobal(item.handle, item.variant_id, item.quantity, true);
				}
			}
		}

		// Remove lone child items
		for (const item of items) {
			const childId = item.properties['_BundleId'];
			if (childId && item.properties['_PartOf'] && !items.some(i => i.key != item.key && i.properties['_BundleId'] == childId)) {
				this.dataset.validating = "true";
				const resp = await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: item.key,
						quantity: 0
					})
				});
			}
		}

		const giftCardsTotal = items.filter(item => item.vendor == 'Giftnote').reduce((acc, item) => acc + item.final_line_price, 0);
		const adjustedTotalPrice = json.total_price - giftCardsTotal;

		// Unified free gift validation
		const giftBlocks = JSON.parse(this.dataset.giftBlocks || '[]');
		const freeGiftItems = items.filter(item => item.properties?.['_FreeGift'] == true);
		const giftRemovals = {};

		// Auto-add: gifts to add this pass, keyed by block. Suppressed (shopper-removed) blocks are skipped.
		const cartAttributes = json.attributes || {};
		const themeId = window.Shopify?.theme?.id;
		const isSuppressed = block => themeId != null && !!cartAttributes[`_FreeGiftRemoved-${themeId}-${block.id}`];
		const giftAdditions = [];

		const allBlockIds = giftBlocks.map(b => b.id);
		for (const gift of freeGiftItems) {
			const blockId = gift.properties?.['_FreeGiftBlock'];
			if (!blockId || !allBlockIds.includes(blockId)) {
				giftRemovals[gift.key] = 0;
			}
		}

		const thresholdBlocks = giftBlocks.filter(b => b.type == 'threshold');
		const thresholdGifts = freeGiftItems.filter(item =>
			thresholdBlocks.some(b => b.id == item.properties?.['_FreeGiftBlock']) &&
			!(item.key in giftRemovals)
		);
		const anyThresholdMet = thresholdBlocks.some(b => adjustedTotalPrice >= b.threshold);

		if (thresholdGifts.length > 0 && !anyThresholdMet) {
			for (const gift of thresholdGifts) giftRemovals[gift.key] = 0;
		}
		else if (thresholdGifts.length > 1) {
			for (const gift of thresholdGifts.slice(0, -1)) giftRemovals[gift.key] = 0;
		}

		// Auto-add a single threshold gift (1 total across threshold blocks) when eligible and none claimed
		const thresholdKept = anyThresholdMet ? Math.min(thresholdGifts.length, 1) : 0;
		if (anyThresholdMet && thresholdKept === 0) {
			const candidate = thresholdBlocks
				.filter(b => b.autoAdd && b.giftVariantId && adjustedTotalPrice >= b.threshold && !isSuppressed(b))
				.sort((a, b) => b.threshold - a.threshold)[0];
			if (candidate) {
				const properties = { _FreeGift: true, _FreeGiftBlock: candidate.id };
				if (candidate.threshold > 0) properties._FreeGiftThreshold = String(candidate.threshold);
				giftAdditions.push({ id: candidate.giftVariantId, quantity: 1, properties });
			}
		}

		for (const block of giftBlocks.filter(b => b.type == 'target_collection')) {
			const blockGifts = freeGiftItems.filter(item =>
				item.properties?.['_FreeGiftBlock'] == block.id &&
				!(item.key in giftRemovals)
			);
			const targetCount = items.filter(item =>
				!item.properties?.['_FreeGift'] &&
				block.targetProductIds.includes(item.product_id) &&
				(!item.properties?.['_BundleItemCount'] || item.properties['_BundleItemCount'] == "5")
			).reduce((acc, item) => acc + item.quantity, 0);

			let giftCount = blockGifts.reduce((acc, item) => acc + item.quantity, 0);
			let excess = giftCount - targetCount;

			for (let i = blockGifts.length - 1; i >= 0 && excess > 0; i--) {
				const gift = blockGifts[i];
				const newQty = Math.max(0, gift.quantity - excess);
				giftRemovals[gift.key] = newQty;
				excess -= (gift.quantity - newQty);
			}

			if (block.autoAdd && block.giftVariantId && !isSuppressed(block) && targetCount > giftCount) {
				giftAdditions.push({ id: block.giftVariantId, quantity: targetCount - giftCount, properties: { _FreeGift: true, _FreeGiftBlock: block.id } });
			}
		}

		// item_components isn't exposed on the Ajax cart line item, so fetch per-item
		// component counts from a cart view template. Only fetch when a bundle gift is
		// actually in the cart and at least one line is a bundle/set worth counting.
		const bundleBlocks = giftBlocks.filter(b => b.type == 'bundle');
		const hasBundleGift = freeGiftItems.some(item =>
			bundleBlocks.some(b => b.id == item.properties?.['_FreeGiftBlock'])
		);
		// Also needed when an auto-add bundle gift could be triggered but isn't in the cart yet
		const hasAutoAddBundle = bundleBlocks.some(b => b.autoAdd && b.giftVariantId && !isSuppressed(b));
		let componentCounts = {};
		if ((hasBundleGift || hasAutoAddBundle) && items.some(item => item.has_components)) {
			const componentsResp = await fetch('/cart?view=bundle-components');
			componentCounts = JSON.parse(await componentsResp.text());
		}

		for (const block of bundleBlocks) {
			const blockGifts = freeGiftItems.filter(item =>
				item.properties?.['_FreeGiftBlock'] == block.id &&
				!(item.key in giftRemovals)
			);
			const bundleCount = items.filter(item =>
				(componentCounts[item.key] || 0) >= block.bundleSize &&
				(!block.byobOnly || item.sku == 'BT-BYOBUNDLE')
			).reduce((acc, item) => acc + item.quantity, 0);

			let giftCount = blockGifts.reduce((acc, item) => acc + item.quantity, 0);
			let excess = giftCount - bundleCount;

			for (let i = blockGifts.length - 1; i >= 0 && excess > 0; i--) {
				const gift = blockGifts[i];
				const newQty = Math.max(0, gift.quantity - excess);
				giftRemovals[gift.key] = newQty;
				excess -= (gift.quantity - newQty);
			}

			if (block.autoAdd && block.giftVariantId && !isSuppressed(block) && bundleCount > giftCount) {
				giftAdditions.push({ id: block.giftVariantId, quantity: bundleCount - giftCount, properties: { _FreeGift: true, _FreeGiftBlock: block.id } });
			}
		}

		if (Object.keys(giftRemovals).length > 0) {
			this.dataset.validating = "true";
			await fetch('/cart/update.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ updates: giftRemovals })
			});
		}

		if (giftAdditions.length > 0) {
			this.dataset.validating = "true";
			await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ items: giftAdditions })
			});
		}

		// Validate pre-order status
		const preorderMonthsResp = await fetch('/cart?view=preorder-months');
		const preorderMonths = JSON.parse(await preorderMonthsResp.text());
		const changes = [];
		
		for (const item of items) {
			if (item.key in preorderMonths && !item.properties.PreOrder?.includes(preorderMonths[item.key])) {
				changes.push({
					id: item.key,
					properties: {
						...item.properties,
						PreOrder: `${preorderMonths[item.key]} delivery`
					}
				});
			}

			if (item.properties.PreOrder && !(item.key in preorderMonths)) {
				changes.push({
					id: item.key,
					properties: {
						...item.properties,
						PreOrder: null
					}
				});
			}
		}
		
		for (const change of changes) {
			this.dataset.validating = "true";
			await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(change)
			});
		}

		this.dataset.validating = "false";
		this.validating = false;
	} 

	applyDisplayOrder() {
		const list = this.querySelector('.cart-items');
		if (!list) return;

		const getLis = () => [...list.children].filter(el => el.tagName === 'LI');
		const maxIterations = getLis().length + 1;

		for (let i = 0; i < maxIterations; i++) {
			const lis = getLis();
			let moved = false;

			for (let idx = 0; idx < lis.length; idx++) {
				const item = lis[idx].querySelector(':scope > cart-item');
				const before = item?.dataset.displayBefore;
				if (!before) continue;

				const beforeKeys = new Set(before.split(',').filter(Boolean));
				let lastAnchorIdx = -1;
				for (let j = 0; j < lis.length; j++) {
					const otherItem = lis[j].querySelector(':scope > cart-item');
					if (otherItem && beforeKeys.has(otherItem.dataset.key)) lastAnchorIdx = j;
				}

				if (lastAnchorIdx > idx) {
					lis[lastAnchorIdx].after(lis[idx]);
					moved = true;
					break;
				}
			}

			if (!moved) break;
		}
	}

	init() {
		this.applyDisplayOrder();

		if (this.discountCode) {
			const code = this.discountCode;

			this.querySelector('a.checkout').addEventListener('click', () => {
				localStorage.setItem(`${code}DiscountApplied`, 'true');
			});

			this.querySelectorAll(`[data-code="${code}"]`).forEach(elem => elem.style.display = '');
			this.querySelector('.cart-footer__total--regular').style.display = 'none';

			if (sessionStorage.getItem(`${code}DiscountAcknowledged`) != 'true') {
				const popup = this.querySelector(`.cart__discount-popup[data-code="${code}"]`);
				
				if (popup) {
					popup.classList.add('active');
					
					popup.querySelector('button').addEventListener('click', () => {
						popup.classList.remove('active');
						popup.classList.add('transition-out');
						setTimeout(() => popup.classList.remove('transition-out'), 300);
						sessionStorage.setItem(`${code}DiscountAcknowledged`, 'true');
					});
				}
			}
		}

		const continueButton = this.querySelector('.cart__continue');
		if (continueButton) continueButton.addEventListener('click', e => this.dispatchEvent(new CustomEvent('continue', { bubbles: true })));

		this.querySelector('.cart__free-gift-atc')?.addEventListener('click', e => {
			if (e.currentTarget.disabled) return;
			e.currentTarget.disabled = true;
			e.currentTarget.classList.add('show-loading');
			this.addFreeGift(e.currentTarget.dataset.id, e.currentTarget.dataset.threshold, e.currentTarget.dataset.blockId);
		});

		// Hide shadow when scroll reaches bottom
		const cartMain = this.querySelector('.cart-main');
		if (cartMain) {
			const checkCartScroll = () => cartMain.classList.toggle('at-bottom', cartMain.scrollHeight - cartMain.scrollTop <= cartMain.clientHeight + 10);

			cartMain.addEventListener('scroll', checkCartScroll, { passive: true });

			const intersectionObserver = new IntersectionObserver(entries => {
				if (entries.some(entry => entry.isIntersecting)) checkCartScroll();
			});
			intersectionObserver.observe(cartMain);
		}

		this.validateCart();
	}

	async addFreeGift(id, threshold, blockId) {
		const properties = {
			_FreeGift: true,
			_FreeGiftBlock: blockId
		};
		if (threshold && parseInt(threshold) > 0) {
			properties._FreeGiftThreshold = threshold;
		}

		await fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				items: [{
					id: id,
					quantity: 1,
					properties
				}]
			})
		});

		this.dataset.giftAdded = 'true';
		setTimeout(() => this.dataset.giftAdded = 'false', 3000);
	}
}

class CartItem extends HTMLElement {
	constructor() {
		super();

		let remove = this.querySelector('button[name="remove"]');
		if (remove) {
			remove.addEventListener('click', async e => {
				e.currentTarget.classList.add('show-loading');
				if (window.trackFSEvent) window.trackFSEvent('Cart Item Remove', cartItemFSProps(this));
				await this.setQuantity(0);
			});
		}

		let increase =	this.querySelector('button[name="increase"]');
		if (increase) {
			increase.addEventListener('click', async e => {
				this.querySelector('.cart-item__quantity-selector').classList.add('show-loading');
				await this.setQuantity(parseInt(this.dataset.quantity) + 1);
			});
		}

		let decrease = this.querySelector('button[name="decrease"]');
		if (decrease) {
			decrease.addEventListener('click', async e => {
				this.querySelector('.cart-item__quantity-selector').classList.add('show-loading');
				await this.setQuantity(Math.max(0, parseInt(this.dataset.quantity) - 1));
			});
		}

		if (this.dataset.bundleId) {
			this.bundleItems = [...this.closest('.cart-items').querySelectorAll(`.cart-item:not(.cart-item--bundle)[data-bundle-id="${this.dataset.bundleId}"]`)];
			let bundleItemsElem = this.closest('.cart-items').querySelector(`.cart-items__bundle-items[data-bundle-id="${this.dataset.bundleId}"]`);
			
			if (bundleItemsElem) {
				bundleItemsElem.style.setProperty('--items', this.bundleItems.length);
				let collapse = this.querySelector('button[name="collapse"]');
				if (collapse) collapse.addEventListener('click', e => this.toggleCollapse());
			}
		}
	}

	toggleCollapse(animate = true) {
		let bundleItemsElem = this.closest('.cart-items').querySelector(`.cart-items__bundle-items[data-bundle-id="${this.dataset.bundleId}"]`);
		let collapse = this.querySelector('button[name="collapse"]');
		bundleItemsElem.style.setProperty('--items', this.bundleItems.length);

		if (!animate) bundleItemsElem.classList.remove('animate');
		else bundleItemsElem.classList.add('animate');

		if (this.dataset.collapsed == 'true') {
			this.dataset.collapsed = 'false';
			bundleItemsElem.classList.remove('collapsed');
			collapse.querySelector('span').innerHTML = 'Hide';
		}
		else {
			this.dataset.collapsed = 'true';
			bundleItemsElem.classList.add('collapsed');
			collapse.querySelector('span').innerHTML = 'Show';
		}
	}

	async setQuantity(quantity) {
		const quantityElem = this.querySelector('.cart-item__quantity');
		if (quantityElem) quantityElem.innerHTML = quantity;

		const updates = {};
		updates[this.dataset.key] = quantity;
		if (this.dataset.linkedKey && (this.dataset.linkedQuantity == 'true' || quantity == 0)) updates[this.dataset.linkedKey] = quantity;

		if (this.dataset.linkedGifts) {
			const reduction = parseInt(this.dataset.quantity) - quantity;
			for (const entry of this.dataset.linkedGifts.split(';')) {
				const parts = entry.split(',');
				if (parts[0] == 't') {
					const [, key, minQty] = parts;
					if (key && quantity < parseInt(minQty)) updates[key] = 0;
				}
				else if (parts[0] == 'b') {
					const excess = parseInt(parts[1]);
					const gifts = parts.slice(2).map(s => {
						const [key, qty] = s.split('=');
						return { key, qty: parseInt(qty) };
					});
					let remaining = Math.max(0, reduction - excess);
					for (let i = gifts.length - 1; i >= 0 && remaining > 0; i--) {
						const gift = gifts[i];
						const newQty = Math.max(0, gift.qty - remaining);
						updates[gift.key] = newQty;
						remaining -= (gift.qty - newQty);
					}
				}
			}
		}

		const body = { updates };

		// Shopper removing/reducing an auto-added gift: suppress future auto-adds for this block (per theme)
		if (quantity < parseInt(this.dataset.quantity) && this.dataset.freeGiftBlock && window.Shopify?.theme?.id) {
			const giftBlocks = JSON.parse(this.closest('cart-contents')?.dataset.giftBlocks || '[]');
			const block = giftBlocks.find(b => b.id == this.dataset.freeGiftBlock);
			if (block?.autoAdd) {
				body.attributes = { [`_FreeGiftRemoved-${window.Shopify.theme.id}-${this.dataset.freeGiftBlock}`]: 'true' };
			}
		}

		let resp = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		});

		if (resp.ok) {
			return true;
		}

		return false;
	}
}

class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.querySelector('.cart-drawer__bg').addEventListener('click', e => this.hide());
		this.querySelector('button[name="close"]').addEventListener('click', e => this.hide());
		
		document.querySelector('.site-header__cart').addEventListener('click', e => {
			e.preventDefault();
			this.show();
		});

		this.addEventListener('continue', e => this.hide());

		const params = new URLSearchParams(window.location.search);
		if (params.get('open_cart') == 'true') this.show();
	}

	async connectedCallback() {
		window.updateCartDrawer = async () => {
			await this.querySelector('cart-contents').promise;
		}

		window.showCartDrawer = (force = false) => {
			if (force) {
				this.show();
			} else {
				if ((theme.storeLocation == 'US' || theme.storeLocation == 'UK' || window.innerWidth < 993) && !document.querySelector('body.template-collection')) {
					window.activateSignifier();
				} else {
					try {
						window.showUpsell()
					} catch (error) {}
				}
			}
		}

		const cartSection = this.querySelector('#shopify-section-cart');
		const cartContents = cartSection?.querySelector('cart-contents');

		if (!cartContents) {
			const resp = await fetch('/?section_id=cart');
			const html = await resp.text();
			this.querySelector('.cart-drawer__contents').insertAdjacentHTML('afterbegin', html);
		}

		this.handleEditorEvents();
	}

	show() {
		if (!this.classList.contains('open')) {
			document.documentElement.classList.add('cart-active');
			document.body.style.overflowY = 'hidden';
			this.classList.add('open', 'transition-in');
			setTimeout(() => this.classList.remove('transition-in'), 300);
		}
	}

	handleEditorEvents() {
		if (Shopify.designMode) {
			document.addEventListener('shopify:section:select', (event) => {
				if (event.detail.sectionId === 'cart') {
					this.show();
				}
			});

			document.addEventListener('shopify:section:deselect', (event) => {
				if (event.detail.sectionId === 'cart') {
					this.hide();
				}
			});
		}
	}

	hide() {
		if (this.classList.contains('open')) {
			this.classList.add('transition-out');
			setTimeout(() => {
				document.documentElement.classList.remove('cart-active');
				document.body.style.overflowY = '';
				this.classList.remove('open', 'transition-out');
			}, 300);
		}
	}
}

class CartItemChangeColour extends HTMLElement {
	constructor() {
		super();

		this.swatches = [...this.querySelectorAll('.change-colour__swatch')];
		this.submitButton = this.querySelector('button[name="submit"]');
		this.submitLabel = this.querySelector('.change-colour__submit-label');
		this.titleElement = this.querySelector('.change-colour__title');
		this.colourNameElement = this.querySelector('.change-colour__colour-name');
		this.picture = this.querySelector('.change-colour__image');
		this.image = this.picture && this.picture.querySelector('img');
		this.source = this.picture && this.picture.querySelector('source');

		this.querySelector('button[name="back"]').addEventListener('click', () => {
			this.closest('slide-out-modal').close();
		});

		for (const swatch of this.swatches) {
			swatch.addEventListener('click', () => {
				if (window.trackFSEvent) {
					window.trackFSEvent('Cart Colour Swatch Select', {
						...cartItemFSProps(this.closest('cart-item')),
						swatchColour: swatch.dataset.colour
					});
				}
				this.selectSwatch(swatch);
			});
		}

		this.submitButton.addEventListener('click', () => this.submit());

		this.closest('slide-out-modal').addEventListener('modalopen', () => {
			if (window.trackFSEvent) window.trackFSEvent('Cart Colour Modal Open', cartItemFSProps(this.closest('cart-item')));
		});

		this.closest('slide-out-modal').addEventListener('modalclose', () => this.reset());
	}

	selectSwatch(swatch) {
		if (this.disabled) return;
		for (const other of this.swatches) other.removeAttribute('aria-pressed');
		swatch.setAttribute('aria-pressed', 'true');

		if (this.titleElement) this.titleElement.textContent = swatch.dataset.title;
		if (this.colourNameElement) this.colourNameElement.textContent = swatch.dataset.colour;

		if (this.image && swatch.dataset.image) {
			this.image.src = swatch.dataset.image;
			if (this.source) this.source.srcset = swatch.dataset.image;
		}

		const isCurrent = swatch.dataset.variantId === this.dataset.currentVariantId;
		const sizeUnavailable = swatch.hasAttribute('data-size-unavailable');

		this.submitButton.disabled = isCurrent || sizeUnavailable;
		if (this.submitLabel) {
			this.submitLabel.textContent = sizeUnavailable ? 'Size unavailable' : 'Save change';
		}
	}

	reset() {
		const currentSwatch = this.swatches.find(s => s.dataset.variantId === this.dataset.currentVariantId);
		if (currentSwatch) this.selectSwatch(currentSwatch);
		this.submitButton.classList.remove('show-loading','show-loading--inverted');
	}

	async submit() {
		if (this.submitButton.disabled) return;

		const selected = this.swatches.find(s => s.getAttribute('aria-pressed') === 'true');
		if (!selected || !selected.dataset.variantId) return;

		window.trackEvent('Side Cart', 'Colour Switch');

		if (window.trackFSEvent) {
			window.trackFSEvent('Cart Colour Edit', {
				...cartItemFSProps(this.closest('cart-item')),
				newColour: selected.dataset.colour
			});
		}

		const handle = selected.dataset.handle;
		const variantId = selected.dataset.variantId;
		const preorderMonth = selected.dataset.preorderMonth || null;
		const isBundle = selected.dataset.isBundle === 'true';
		const quantity = parseInt(this.dataset.quantity) || 1;

		const itemEl = this.closest('cart-item');
		const li = itemEl?.closest('li');
		const aboveKeys = [];
		let prev = li?.previousElementSibling;
		while (prev) {
			if (prev.tagName === 'LI') {
				const sibling = prev.querySelector(':scope > cart-item');
				if (sibling?.dataset.key) aboveKeys.unshift(sibling.dataset.key);
			}
			prev = prev.previousElementSibling;
		}
		const properties = { _Edited: true };
		if (aboveKeys.length > 0) properties._DisplayBefore = aboveKeys.join(',');

		if (this.dataset.freeGift === 'true') {
			properties._FreeGift = true;
			properties._FreeGiftBlock = this.dataset.freeGiftBlock;
			if (this.dataset.freeGiftThreshold) properties._FreeGiftThreshold = this.dataset.freeGiftThreshold;
		}

		this.submitButton.classList.add('show-loading', 'show-loading--inverted');
		this.submitButton.disabled = true;
		this.disabled = true;

		window.preventCartUpdate = true;

		try {
			await fetch('/cart/change.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ id: this.dataset.key, quantity: 0 })
			});

			await addToCartGlobal(handle, variantId, quantity, isBundle, preorderMonth, properties);
		} finally {
			window.preventCartUpdate = false;
		}

		const cart = document.querySelector('cart-contents');
		if (cart) await cart.update();
	}
}

if (!customElements.get('cart-contents')) customElements.define('cart-contents', CartContents);
if (!customElements.get('cart-item')) customElements.define('cart-item', CartItem);
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
if (!customElements.get('cart-item-change-colour')) customElements.define('cart-item-change-colour', CartItemChangeColour);